module.exports = "https://www.gc-pro.gnp.com.mx/4f26761ec6ed55ef1ec50674a93d5d4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/appbannerresp2020.jpg
// module id = 8057
// module chunks = 0